const DATE_RANGE_OPTIONS = [    
    { "Id": 1, "Title": "Today", "Value": 1 },
    { "Id": 2, "Title": "Last 7 Days", "Value": 7 },
    { "Id": 3, "Title": "Last 30 Days", "Value": 30 },
   // { "Id": 4, "Title": "Last 3 Months", "Value": 90 },
    { "Id": 5, "Title": "Last 180 Days", "Value": 180 },
    { "Id": 6, "Title": "Choose My Own Date Range", "Value": -1 }
];

export default DATE_RANGE_OPTIONS;


// WEBPACK FOOTER //
// ./features/check-my-numbers/DATE_RANGE_OPTIONS.js